import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch, onMounted } from 'vue';
import {
  HelperView,
  Modal,
  HeadingDisplay,
  ButtonContainer,
  ButtonPrimary,
  ButtonSecondary,
  StatusMessage,
  LoaderIndicator,
  InitialAvatarIcon
} from '@warrenbrasil/nebraska-web';
import { WithdrawSteps } from './components/WithdrawSteps';
import { InvestmentSteps } from './components/InvestmentSteps';
import { IOrderReceipt } from '@/modules/wealth/services/wealth-orders/types';
import {
  addBodyScrollWithScrollTo,
  removeBodyScroll
} from '@/modules/common/helpers/browser';
import { cancelOrder } from '@/modules/wealth/services/wealth-orders/wealth-orders';
import {
  IStep,
  ModalSteps
} from '@/modules/wealth/views/WealthPortfolioV2/components/Orders/components/OrderDetails/types';

enum States {
  INVESTMENT_BY_PRODUCT,
  WITHDRAW_BY_PRODUCT
}


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderDetails',
  props: {
    isOpen: { type: Boolean },
    orderId: null,
    orderData: null,
    loading: { type: Boolean },
    error: { type: Boolean }
  },
  emits: [
  'reload',
  'close',
  'requestOrderReceipt',
  'handle-instrument-details-click'
],
  setup(__props: any, { emit }) {

const props = __props as {
  isOpen: boolean;
  orderId: string;
  orderData: IOrderReceipt | null;
  loading: boolean;
  error: boolean;
}





const isLoadingCancel = ref(false);
const modalStep = ref(ModalSteps.Initial);

const state = computed(() => {
  return props.orderData?.direction === 'Investment'
    ? States.INVESTMENT_BY_PRODUCT
    : States.WITHDRAW_BY_PRODUCT;
});

const isInvestment = computed(() => {
  return state.value === States.INVESTMENT_BY_PRODUCT;
});

const headTitle = computed(() => {
  return isInvestment.value
    ? 'Investimento em carteira'
    : 'Resgate em carteira';
});

const title = computed(() => {
  return props.orderData?.portfolioName || '';
});

const subtitle = computed(() => {
  const label = isInvestment.value ? 'Origem' : 'Destino';
  return `${label}: ${props.orderData?.toPortfolio}`;
});

const cancelButtonLabel = computed(() => {
  return isInvestment.value ? 'Cancelar investimento' : 'Cancelar resgate';
});

const cancelHeading = computed(() => {
  return isInvestment.value ? 'Cancelar investimento?' : 'Cancelar resgate?';
});

const progressBar = computed<IStep[]>(() => {
  if (!props.orderData?.historicStatus) return [];
  return props.orderData.historicStatus.map(step => {
    return {
      progress: step.progress,
      description: step.date || undefined,
      title: step.value
    };
  });
});

const handleCancelOrderClick = async () => {
  if (modalStep.value === ModalSteps.Initial) {
    modalStep.value = ModalSteps.Cancel;
  } else {
    try {
      isLoadingCancel.value = true;
      await cancelOrder(props.orderId);
      emit('reload');
      emit('close');
      modalStep.value = ModalSteps.Initial;
    } catch (e) {
      console.log(e);
      modalStep.value = ModalSteps.CancelError;
    }
  }
  isLoadingCancel.value = false;
};

watch(
  () => props.isOpen,
  isOpen => {
    modalStep.value = ModalSteps.Initial;
    if (isOpen) {
      removeBodyScroll();
    } else {
      addBodyScrollWithScrollTo();
    }
  },
  { immediate: true }
);

onMounted(() => {
  modalStep.value = ModalSteps.Initial;
});

return { __sfc: true,States, props, emit, isLoadingCancel, modalStep, state, isInvestment, headTitle, title, subtitle, cancelButtonLabel, cancelHeading, progressBar, handleCancelOrderClick, HelperView, Modal, HeadingDisplay, ButtonContainer, ButtonPrimary, ButtonSecondary, StatusMessage, LoaderIndicator, InitialAvatarIcon, WithdrawSteps, InvestmentSteps, ModalSteps }
}

})